import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";

/* ---------------- GLOBAL CSS IMPORTS ---------------- */
import "/public/assets/vendor/bootstrap/css/bootstrap.min.css";
import "/public/assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "/public/assets/vendor/aos/aos.css";
import "/public/assets/vendor/glightbox/css/glightbox.min.css";
import "/public/assets/vendor/swiper/swiper-bundle.min.css";
import "/public/assets/css/main.css";
/* ---------------------------------------------------- */

ReactDOM.createRoot(document.getElementById("root")).render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
